import { FC } from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi';
import {
  ButtonProps,
  Flex,
  FlexProps,
  Icon,
  Spinner,
  Text,
} from '@chakra-ui/react';

type NavButtonProps = FlexProps & ButtonProps;

export const NavButton: FC<NavButtonProps> = ({
  children,
  loading,
  ...props
}) => (
  <Flex
    _hover={{ bg: 'gray.25' }}
    alignItems="center"
    as="button"
    borderWidth="1px"
    cursor={loading ? 'not-allowed' : 'pointer'}
    disabled={loading || undefined}
    justifyContent="space-between"
    p={4}
    transition="all 150ms"
    type="button"
    w="full"
    {...props}
  >
    <Text>{children}</Text>

    <Icon
      as={loading ? Spinner : HiOutlineChevronRight}
      boxSize={4}
      color="red.400"
      ml={4}
    />
  </Flex>
);
